/** Small pieces shared by the Company tabs. */

export const formatDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—');

export function CardStatus({ status }) {
  const live = status === 'active';
  return (
    <span className={`h-6 px-2 rounded-full text-xs font-semibold inline-flex items-center gap-1.5 whitespace-nowrap ${live ? 'bg-blue-soft text-blue' : 'bg-coral-soft text-coral-ink'}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${live ? 'bg-blue' : 'bg-coral-ink'}`} />
      {live ? 'Live' : status === 'draft' ? 'Draft' : 'Suspended'}
    </span>
  );
}

const ROLE_STYLE = {
  owner: 'bg-navy text-white',
  admin: 'bg-blue-soft text-blue',
  member: 'bg-surface text-ink-muted border border-line',
};

export function RoleBadge({ role }) {
  return (
    <span className={`h-6 px-2.5 rounded-full text-xs font-semibold inline-flex items-center capitalize ${ROLE_STYLE[role] || ROLE_STYLE.member}`}>
      {role}
    </span>
  );
}
